// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"6743b9f7","216":"4c886509","447":"82f510a0","453":"e5b91d18","772":"d908a9c8","916":"b3c49461"}[chunkId] + ".chunk.js";
};